export default "__VITE_ASSET__9e240f29__"